"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotlistResult = void 0;
const HotlistValue_1 = require("./HotlistValue");
class HotlistResult {
    constructor(obj, units) {
        this.rank = obj.rank;
        this.symbol = obj.symbol;
        this.values = [];
        // This assumes that formatted, values and units have
        // the same length.
        for (let i = 0; i < obj.formatted.length; i++) {
            this.values.push(new HotlistValue_1.HotlistValue({
                raw: obj.values[i],
                formatted: obj.formatted[i],
                unit: units[i]
            }));
        }
    }
}
exports.HotlistResult = HotlistResult;
//# sourceMappingURL=HotlistResult.js.map